export default "__VITE_ASSET__DxMf9LtX__"